// MODÜL 9: BİREBİR MÜLAKAT SİMÜLASYONU - ZENGİN İÇERİK

const cabinCrewContentsM9Extra = {
  // ==================== ÜNİTE 4: DAVRANIŞSAL SORULAR ====================
  'CM-M9-U4-L1': {
    lesson_id: 'CM-M9-U4-L1',
    title: 'Davranışsal Soru Nedir?',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Behavioral Interview Questions',
      paragraphs: [
        'Davranışsal soru: "Geçmişte [X] durumunda ne yaptınız?" tipi sorular.',
        'Mantık: Geçmiş davranış, gelecek davranışı tahmin eder.',
        'Örnekler: "Zor bir müşteriyle nasıl başa çıktınız?", "Ekip içi anlaşmazlık yaşadınız mı?"',
        'Cevap yapisi: STAR metodu ile cevapla. Situation-Task-Action-Result.',
        'Dikkat: Somut örnek ver. "Genellikle şöyle yaparım" DEĞİL, "Geçen ay şunu yaptım" DE.'
      ],
      keyPoints: [
        'Geçmiş davranışı sorar',
        'STAR metodu kullan',
        'Somut örnek ver',
        '"Genellikle" deme, gerçek örnek ver'
      ]
    }
  },
  'CM-M9-U4-L2': {
    lesson_id: 'CM-M9-U4-L2',
    title: 'Zor Müşteri Sorusu',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: '"Zor Bir Müşteriyle Nasıl Başa Çıktınız?"',
      paragraphs: [
        'Bu soru KESINLIKLE sorulacak. Hazırlıklı ol!',
        'S (Situation): "Kafede çalışırken, bir müşteri siparişinin yanlış geldiğini söyledi."',
        'T (Task): "Sorunu çözmem ve müşteriyi memnun etmem gerekiyordu."',
        'A (Action): "Önce onu dinledim, özür diledim, hemen yeni sipariş hazırladım ve ücretsin ikram ettim."',
        'R (Result): "Müşteri memnun ayrıldı ve sonraki hafta tekrar geldi."'
      ],
      keyPoints: [
        'Hazırlıklı ol',
        'Dinleme + Özür + Çözüm',
        'Olumlu sonuç vurgula',
        'Gerçek örnek kullan'
      ]
    }
  },
  'CM-M9-U4-L3': {
    lesson_id: 'CM-M9-U4-L3',
    title: 'Ekip Anlaşmazlığı Sorusu',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: '"Ekip İçinde Anlaşmazlık Yaşadınız mı?"',
      paragraphs: [
        'Amaç: Takım çalışması ve çatışma yönetimi becerisini ölçmek.',
        'S: "Üniversite projesinde, bir arkadaşım işini yapmıyordu."',
        'T: "Projeyi tamamlamamız ve ekip uyumunu korumamız gerekiyordu."',
        'A: "Onunla özel konuştum, sorununu dinledim, görevleri yeniden dağıttık."',
        'R: "Projeyi zamanında bitirdik ve arkadaşlığımız da devam etti."',
        'Dikkat: Asla birisini suçlama. Yapıcı çözüme odaklan.'
      ],
      keyPoints: [
        'Suçlama yapma',
        'Özel konuşma vurgula',
        'Çözüm odaklı ol',
        'İlişkiyi koru'
      ]
    }
  },
  'CM-M9-U4-L4': {
    lesson_id: 'CM-M9-U4-L4',
    title: 'Senaryo: Davranışsal Soru',
    type: 'scenario',
    duration: 10,
    xp: 50,
    scenario: {
      question: '"Stres altında çalıştığınız bir durumu anlatın." En iyi cevap yapısı?',
      context: 'Değerlendirmeci baskı altında performansınızı ölçmek istiyor.',
      options: [
        { id: 'A', text: '"Stresli ortamlarda rahatım, hiç sorun yaşamadım."', isCorrect: false },
        { id: 'B', text: '"Final haftasında 3 sınava hazırlandım. Plan yaptım, öncelikledirdim, hepsinden geçtim."', isCorrect: true },
        { id: 'C', text: '"Stres beni çok etkiler, zorlanırım."', isCorrect: false },
        { id: 'D', text: '"Bilmiyorum, hatırlamıyorum."', isCorrect: false }
      ],
      feedback: {
        correct: 'Mükemmel! Somut durum + eylem + olumlu sonuç = STAR formatı.',
        wrong: 'Hatalı. A gerçekçi değil, C negatif, D hazırlıksız. B ideal STAR cevabı.'
      },
      explanation: 'Davranışsal soruda: 1) Somut örnek, 2) Ne YAPTIN, 3) Olumlu sonuç.'
    }
  },
  'CM-M9-U4-L5': {
    lesson_id: 'CM-M9-U4-L5',
    title: '🎮 Davranışsal Sorular Quiz',
    type: 'quiz',
    duration: 5,
    xp: 45,
    quiz: {
      questions: [
        { q: 'Davranışsal sorular neyi ölçer?', options: ['Bilgi', 'Geçmiş davranış', 'IQ', 'Yaş'], correct: 1 },
        { q: 'STAR\'da A ne demek?', options: ['Answer', 'Action', 'Always', 'After'], correct: 1 },
        { q: '"Genellikle şöyle yaparım" iyi mi?', options: ['Evet', 'Hayır', 'Bazen', 'Her zaman'], correct: 1 },
        { q: 'Ekip anlaşmazlığında ne yapmamalı?', options: ['Dinlemek', 'Suçlamak', 'Çözmek', 'Konuşmak'], correct: 1 },
        { q: 'Sonuç olumlu olmalı mı?', options: ['Evet', 'Hayır', 'Fark etmez', 'Olumsuz da olur'], correct: 0 }
      ]
    }
  },

  // ==================== ÜNİTE 5: ZOR SORULAR ====================
  'CM-M9-U5-L1': {
    lesson_id: 'CM-M9-U5-L1',
    title: 'Zayıf Yön Sorusu',
    type: 'lesson',
    duration: 5,
    xp: 30,
    content: {
      title: '"Zayıf Yönünüz Nedir?"',
      paragraphs: [
        'En korkutucu soru! Ama doğru cevaplanırsa AVANTAJ.',
        'YAPMA: "Zayıf yönüm yok" - Kibirli ve gerçekçi değil.',
        'YAPMA: "Mükemmeliyetçiyim" - Klişe. Herkes söylüyor.',
        'YAPMA: "İngilizcemi zayıf" - Kritik zayıflık. Kariyer engelleyici.',
        'YAP: Gerçek ama kritik olmayan zayıflık + Gelişim çabası.',
        'Örnek: "Bazen çok detaya takılıyorum ama öncelik belirlemeyi öğrendim."'
      ],
      keyPoints: [
        '"Yok" deme',
        '"Mükemmeliyetci" klişe',
        'Kritik zayıflık söyleme',
        'Gelişim çabası ekle'
      ]
    }
  },
  'CM-M9-U5-L2': {
    lesson_id: 'CM-M9-U5-L2',
    title: 'Maaş Beklentisi Sorusu',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: '"Maaş Beklentiniz Nedir?"',
      paragraphs: [
        'Kabin memuru mülakatında NADİR sorulur ama hazırlıklı ol.',
        'Araştır: Havayolunun maaş aralığını bil. İnternet\'te var.',
        'İdeal cevap: "Sektör standartlarına uygun olmasını bekliyorum."',
        'Alternatif: "[X] TL ile [Y] TL arası düşünüyorum, deneyimime göre."',
        'Dikkat: Maaşı ana motivasyon olarak gösterme!'
      ],
      keyPoints: [
        'Sektör standartlarını araştır',
        'Aralık ver, tek rakam değil',
        'Maaşı ana motivasyon yapma',
        'Esnek ol'
      ]
    }
  },
  'CM-M9-U5-L3': {
    lesson_id: 'CM-M9-U5-L3',
    title: '5 Yıl Sonra Sorusu',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: '"5 Yıl Sonra Kendinizi Nerede Görüyorsunuz?"',
      paragraphs: [
        'Amaç: Kariyer planlılığı ve şirkete bağlılığı ölçmek.',
        'YAPMA: "CEO olmak istiyorum" - Gerçekçi değil.',
        'YAPMA: "Bilmiyorum" - Plansız görünürsün.',
        'YAPMA: "Başka havayolunda" - Sadık değilsin!',
        'YAP: "Deneyimli kabin memuru olarak, belki kıdemli pozisyonda, bu şirkette gelişmek istiyorum."'
      ],
      keyPoints: [
        'Gerçekçi hedef',
        'Şirkete bağlılık göster',
        'Gelişim isteği',
        '"Bilmiyorum" deme'
      ]
    }
  },
  'CM-M9-U5-L4': {
    lesson_id: 'CM-M9-U5-L4',
    title: 'Neden Sizi Seçelim Sorusu',
    type: 'lesson',
    duration: 5,
    xp: 30,
    content: {
      title: '"Neden Sizi Seçmeliyiz?"',
      paragraphs: [
        'Kendinizi satma zamanı! Ama kibirsiz.',
        'Formül: Güçlü yönün + Rol ile bağlantı + Katkı.',
        'Örnek: "Hizmet sektörü deneyimim ve iletişim becerim, yolculara mükemmel hizmet sunmamı sağlar."',
        'Örnek: "Çok dilli olmam, uluslararası yolculara yardımcı olur."',
        'Dikkat: "Ben en iyisiyim" deme. Dengeli özgüven.'
      ],
      keyPoints: [
        'Güçlü yönü vurgula',
        'Rol ile bağla',
        'Katkıyı belirt',
        'Kibirsiz ol'
      ]
    }
  },
  'CM-M9-U5-L5': {
    lesson_id: 'CM-M9-U5-L5',
    title: 'Senaryo: Zor Soru',
    type: 'scenario',
    duration: 10,
    xp: 50,
    scenario: {
      question: '"En büyük başarısızlığınız neydi?" En iyi cevap?',
      context: 'Değerlendirmeci öz farkındalık ve öğrenme yeteneğini test ediyor.',
      options: [
        { id: 'A', text: '"Hiç başarısız olmadım."', isCorrect: false },
        { id: 'B', text: '"Sınavdan kaldım ve çok kötü hissettim."', isCorrect: false },
        { id: 'C', text: '"Bir projede zaman yönetimini beçeremedim. Bundan sonra planlama yapmayı öğrendim."', isCorrect: true },
        { id: 'D', text: '"Başarısızlık hakkında düşünmek istemiyorum."', isCorrect: false }
      ],
      feedback: {
        correct: 'Mükemmel! Başarısızlık + Öğrenim = Growth mindset gösteriyorsun.',
        wrong: 'Hatalı. A gerçekçi değil, B öğrenim yok, D kaçınma. C ideal.'
      },
      explanation: 'Başarısızlık sorusu: 1) Gerçek örnek, 2) Ne öğrendiğini söyle, 3) Nasıl geliştiğini anlat.'
    }
  },
  'CM-M9-U5-L6': {
    lesson_id: 'CM-M9-U5-L6',
    title: '⚡ Zor Sorular Yarışı',
    type: 'timerace',
    duration: 5,
    xp: 55,
    timerace: {
      timePerQuestion: 8,
      questions: [
        { q: 'Zayıf yön sorusunda ne dememeli?', options: ['Yok', 'Var', 'Geliştirdim', 'Çalışıyorum'], correct: 0 },
        { q: '5 yıl sonra nerede olmalısın?', options: ['CEO', 'Bu şirkette', 'Başka şirkette', 'Bilmiyorum'], correct: 1 },
        { q: '"Mükemmeliyetci" cevabı iyi mi?', options: ['Evet', 'Hayır, klişe', 'Mükemmel', 'Her zaman'], correct: 1 },
        { q: 'Başarısızlık sorusunda ne önemli?', options: ['Ağlama', 'Öğrenim', 'Suçlama', 'Kaçınma'], correct: 1 },
        { q: '"Neden sizi seçelim" sorusuna?', options: ['Bilmiyorum', 'En iyisiyim', 'Güçlü yön + Katkı', 'Maaş'], correct: 2 }
      ]
    }
  },

  // ==================== ÜNİTE 6: ŞİRKET BİLGİSİ ====================
  'CM-M9-U6-L1': {
    lesson_id: 'CM-M9-U6-L1',
    title: 'Şirketi Araştırma',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Havayolunu Araştır',
      paragraphs: [
        'ZORUNLU: Başvurduğun havayolunu çok iyi tanımalısın!',
        'Temel bilgiler: Kuruluş tarihi, hub\'lar, filo, destinasyon sayısı.',
        'Slogan ve değerler: "Widen Your World" (THY), "Herkes Uçabilir" (Pegasus).',
        'İttifak: Star Alliance (THY), Oneworld (BA), SkyTeam (Air France).',
        'Son haberler: Yeni uçak teslimatı, yeni rota, ödüller. Mülakattan 1 hafta önce oku!'
      ],
      keyPoints: [
        'Kuruluş, hub, filo',
        'Slogan ve değerler',
        'İttifak bil',
        'Son haberleri oku'
      ]
    }
  },
  'CM-M9-U6-L2': {
    lesson_id: 'CM-M9-U6-L2',
    title: 'Neden Bu Havayolu Sorusu',
    type: 'lesson',
    duration: 5,
    xp: 30,
    content: {
      title: '"Neden [X] Havayolları\'nda Çalışmak İstiyorsunuz?"',
      paragraphs: [
        'Bu soru KESINLIKLE sorulacak. Hazırlıklı ol!',
        'YAPMA: "Para kazanmak istiyorum" - Herkes istiyor.',
        'YAPMA: "Gezmek istiyorum" - Yüzeysel.',
        'YAPMA: "Aile istiyor" - Kendi motivasyonun yok.',
        'YAP: Şirkete özgü + Kişisel değerlerle bağlantı.',
        'Örnek (THY): "En çok ülkeye uçan havayolu olarak farklı kültürlerle çalışma fırsatı sunuyor."'
      ],
      keyPoints: [
        'Şirkete özgü bilgi kullan',
        'Kişisel değerlerle bağla',
        '"Para/Gezme" deme',
        'Araştırdığını göster'
      ]
    }
  },
  'CM-M9-U6-L3': {
    lesson_id: 'CM-M9-U6-L3',
    title: 'Senaryo: Şirket Bilgisi',
    type: 'scenario',
    duration: 8,
    xp: 45,
    scenario: {
      question: '"Neden THY?" sorusuna en iyi cevap?',
      context: 'THY mülakatında bu soru soruldu.',
      options: [
        { id: 'A', text: '"En büyük Türk havayolu olduğu için."', isCorrect: false },
        { id: 'B', text: '"THY\'nin 130+ ülkeye uçması ve farklı kültürlerle çalışma vizyonu kariyer hedeflerimle örtüşüyor."', isCorrect: true },
        { id: 'C', text: '"Maaşları iyi."', isCorrect: false },
        { id: 'D', text: '"Ailem istedi."', isCorrect: false }
      ],
      feedback: {
        correct: 'Mükemmel! Şirkete özgü bilgi (130+ ülke) + Kişisel bağlantı = İdeal.',
        wrong: 'Hatalı. A yeterince özel değil, C/D yanlış motivasyon. B araştırma gösteriyor.'
      },
      explanation: '"Neden bu havayolu" = Şirkete özgü bilgi + Senin değerlerinle bağlantı.'
    }
  },
  'CM-M9-U6-L4': {
    lesson_id: 'CM-M9-U6-L4',
    title: '🎮 Şirket Bilgisi Doğru/Yanlış',
    type: 'truefalse',
    duration: 4,
    xp: 35,
    truefalse: {
      statements: [
        { statement: 'Mülakatta havayolu hakkında soru sorulmaz.', isTrue: false, explanation: 'Yanlış! "Neden bu havayolu" kesin sorulur.' },
        { statement: 'Şirketi araştırmak önemlidir.', isTrue: true, explanation: 'Doğru! Araştırma = Ciddiyet gösterir.' },
        { statement: '"Para kazanmak" iyi bir motivasyondur.', isTrue: false, explanation: 'Yanlış! Herkes para istiyor, özel değil.' },
        { statement: 'Son haberleri okumak yararlıdır.', isTrue: true, explanation: 'Doğru! Güncel bilgi = Ciddi aday.' },
        { statement: 'İttifak bilgisi gereksizdir.', isTrue: false, explanation: 'Yanlış! İttifak bilmek = Sektörü tanıyorsun.' }
      ]
    }
  },

  // ==================== ÜNİTE 7: SORU SORMA ====================
  'CM-M9-U7-L1': {
    lesson_id: 'CM-M9-U7-L1',
    title: 'Mülakat Sonunda Soru Sorma',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: '"Sormak İstediğiniz Bir Şey Var mı?"',
      paragraphs: [
        'Bu soru mülakat sonunda KESINLIKLE sorulur. Hazırlıklı ol!',
        'YAPMA: "Hayır, yok." - İlgisiz görünürsün.',
        'YAPMA: "Maaş ne kadar?" - İlk sorun bu olmamalı.',
        'YAPMA: "Tatil günleri?" - Henüz işe girmedin!',
        'YAP: Eğitim, kariyer gelişimi, ekip yapısı hakkında sor.',
        'Örnek: "Eğitim süreci hakkında bilgi alabilir miyim?"'
      ],
      keyPoints: [
        'Mutlaka soru sor',
        'Maaş/tatil sorma',
        'Eğitim, gelişim sor',
        '2-3 soru hazırla'
      ]
    }
  },
  'CM-M9-U7-L2': {
    lesson_id: 'CM-M9-U7-L2',
    title: 'Sorulabilecek Sorular',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'İyi Soru Örnekleri',
      paragraphs: [
        '"Eğitim süreci ne kadar sürüyor ve neler içeriyor?"',
        '"Yeni başlayan kabin memurları için kariyer gelişim fırsatları neler?"',
        '"Ekip yapısı nasıl? Her uçuşta farklı ekiplerle mi çalışılıyor?"',
        '"Şirketinizin kabin ekibinden beklediği en önemli özellik nedir?"',
        'Dikkat: 2-3 soru yeterli. Çok soru sorma.'
      ],
      keyPoints: [
        'Eğitim süreci sor',
        'Kariyer gelişimi sor',
        'Ekip yapısı sor',
        '2-3 soru yeterli'
      ]
    }
  },
  'CM-M9-U7-L3': {
    lesson_id: 'CM-M9-U7-L3',
    title: 'Senaryo: Soru Sorma',
    type: 'scenario',
    duration: 8,
    xp: 40,
    scenario: {
      question: '"Sormak istediğiniz bir şey var mı?" En iyi cevap?',
      context: 'Mülakat sona eriyor.',
      options: [
        { id: 'A', text: '"Hayır, teşekkürler."', isCorrect: false },
        { id: 'B', text: '"Maaş ne kadar ve tatil günleri ne zaman?"', isCorrect: false },
        { id: 'C', text: '"Eğitim süreci ve kariyer gelişim fırsatları hakkında bilgi alabilir miyim?"', isCorrect: true },
        { id: 'D', text: '"Ne zaman sonuç açıklanır?"', isCorrect: false }
      ],
      feedback: {
        correct: 'Mükemmel! Eğitim ve kariyer sorusu = İlgi ve ciddiyet gösterir.',
        wrong: 'Hatalı. A ilgisiz, B erken, D sabırsız. C profesyonel ve ilgili.'
      },
      explanation: 'Mülakat sonu sorusu: Eğitim, gelişim, ekip hakkında. Maaş/tatil değil.'
    }
  },

  // ==================== ÜNİTE 8: FİNAL SİMÜLASYON ====================
  'CM-M9-U8-L1': {
    lesson_id: 'CM-M9-U8-L1',
    title: 'Tam Simülasyon: Açılış',
    type: 'scenario',
    duration: 10,
    xp: 50,
    scenario: {
      question: 'Değerlendirmeci: "Hoş geldiniz. Kendinizi tanıtır mısınız?" En iyi başlangıç?',
      context: 'Birebir mülakat başlıyor. İlk izlenim çok önemli!',
      options: [
        { id: 'A', text: '"1998\'de İstanbul\'da doğdum, sonra lise, sonra üniversite..."', isCorrect: false },
        { id: 'B', text: '"Merhaba, hizmet sektöründe 2 yıl deneyimim var. İletişim güçlü yönüm."', isCorrect: true },
        { id: 'C', text: '"Ne söylememi istiyorsunuz?"', isCorrect: false },
        { id: 'D', text: 'Sessiz kalıp düşünürüm', isCorrect: false }
      ],
      feedback: {
        correct: 'Mükemmel! Profesyonel özet + Güçlü yön = İdeal tanıtım.',
        wrong: 'Hatalı. A biyografik, C hazırlıksız, D sessiz. B profesyonel.'
      },
      explanation: 'Kendini tanıt: Profesyonel özet (10 sn) + Güçlü yön (20 sn) + Şirkete bağlantı (10 sn).'
    }
  },
  'CM-M9-U8-L2': {
    lesson_id: 'CM-M9-U8-L2',
    title: 'Tam Simülasyon: Zor An',
    type: 'scenario',
    duration: 10,
    xp: 50,
    scenario: {
      question: 'Değerlendirmeci hiç gülümsemiyor, sert sorular soruyor. Ne yaparsınız?',
      context: 'Stres mülakatı olabilir. Test ediliyor olabilirsin.',
      options: [
        { id: 'A', text: 'Sinirlenip agresif cevaplar veririm', isCorrect: false },
        { id: 'B', text: 'Sakin kalır, gülümser, profesyonel cevaplar veririm', isCorrect: true },
        { id: 'C', text: 'Ağlamaya başlarım', isCorrect: false },
        { id: 'D', text: '"Neden bu kadar sersiniz?" diye sorarım', isCorrect: false }
      ],
      feedback: {
        correct: 'Mükemmel! Stres altında sakinlik = Kabin ekibi için kritik beceri.',
        wrong: 'Hatalı. Stres mülakatı TEST. Sakin kal, profesyonel ol.'
      },
      explanation: 'Stres mülakatı: 1) Sakin kal, 2) Gülümse, 3) Profesyonel cevap ver, 4) Kişisel alma.'
    }
  },
  'CM-M9-U8-L3': {
    lesson_id: 'CM-M9-U8-L3',
    title: 'Tam Simülasyon: Kapanış',
    type: 'scenario',
    duration: 10,
    xp: 50,
    scenario: {
      question: 'Mülakat bitiyor. En iyi kapanış?',
      context: 'Son izlenim de önemli!',
      options: [
        { id: 'A', text: 'Hızla kalkar, "Görüşürüz" der çıkarım', isCorrect: false },
        { id: 'B', text: 'Teşekkür eder, tokalaşır, gülümser, ismiyle hitap ederim', isCorrect: true },
        { id: 'C', text: '"Ne zaman sonuç açıklanır?" diye ısrarla sorarım', isCorrect: false },
        { id: 'D', text: 'Sessizce kalkar çıkarım', isCorrect: false }
      ],
      feedback: {
        correct: 'Mükemmel! Teşekkür + Tokalaşma + Gülümseme + İsim = Profesyonel kapanış.',
        wrong: 'Hatalı. Son izlenim de kritik. Teşekkür et, gülümse, tokalaş.'
      },
      explanation: 'Kapanış: 1) Ayak, 2) Teşekkür, 3) Tokalaşma, 4) Gülümseme, 5) "[isim] Bey/Hanım, teşekkürler"'
    }
  },
  'CM-M9-U8-L4': {
    lesson_id: 'CM-M9-U8-L4',
    title: 'Birebir Mülakat Final Quiz',
    type: 'exam',
    duration: 15,
    xp: 100,
    exam: {
      questions: [
        { q: 'STAR\'da S ne demek?', options: ['Solution', 'Situation', 'Success', 'Story'], correct: 1 },
        { q: 'Zayıf yön sorusunda ne dememeli?', options: ['Var', 'Geliştirdim', 'Yok', 'Çalışıyorum'], correct: 2 },
        { q: '5 yıl sonra nerede olmalısın?', options: ['CEO', 'Bu şirkette', 'Rakipte', 'Emekli'], correct: 1 },
        { q: '"Neden bu havayolu" sorusuna?', options: ['Para', 'Gezme', 'Şirkete özgü bilgi', 'Aile istedi'], correct: 2 },
        { q: 'Mülakat sonunda ne sorulmalı?', options: ['Maaş', 'Tatil', 'Eğitim', 'Hiç'], correct: 2 },
        { q: 'Kendini tanıtma süresi?', options: ['5 dakika', '30-60 saniye', '10 saniye', '3 dakika'], correct: 1 },
        { q: 'Stres mülakatında ne yapmalı?', options: ['Sinirlen', 'Ağla', 'Sakin kal', 'Git'], correct: 2 },
        { q: 'Kapanışta ne yapmalı?', options: ['Hızla git', 'Teşekkür + Tokalaş', 'Sonuç sor', 'Sessiz çık'], correct: 1 },
        { q: 'Başarısızlık sorusunda ne önemli?', options: ['Ağlamak', 'Öğrenim', 'Suçlamak', 'Kaçınmak'], correct: 1 },
        { q: 'Davranışsal soruda ne gerekli?', options: ['Genel ifade', 'Somut örnek', 'Teori', 'Yalan'], correct: 1 }
      ]
    }
  }
};

export default cabinCrewContentsM9Extra;
